import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, RouterModule } from "@angular/router";

import { SettingsCustomFormsService } from '@app/services/settings/custom-forms.service';
import { AppService } from '@app/services/app/app.service';

import { Form } from '@core/objects/form';

import { TitleService } from '@core/services/title.service';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';


@Component({
    selector: 'settings-forms-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsFormsMainComponent implements OnInit, OnDestroy{
    private readonly ACCESS = 'access_setting_custom_forms';    

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    public forms: Array<Form>;
	public showForm:boolean = false;
	public access: boolean = true;
    public status: number = this.STATUS_LOADING;
    public readyList: boolean = false;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        }
    ];


	public menu: Array<ThreeDotsMenuItem> = [{
		title: "Add a new form",
		key: "add-form",
		icon: "add",
		order: 1
	}];

    protected formsListSubscriptor: Subscription;
    protected sessionSubscriptor: Subscription;
    protected formsInitializedSubscriptor: Subscription;

	constructor(
        public formsSrv: SettingsCustomFormsService, 
        public app: AppService, 
        private title: TitleService, 
        private router: Router){}

	ngOnInit(){
        this.title.set("Forms - System settings");
        this.sessionSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            if (this.access){
                this.load();
            }
        });
        

        this.formsListSubscriptor = this.formsSrv.selectForms().subscribe((forms: Array<Form>) => {
            this.forms = forms;
            this.initView();
        });

        this.formsInitializedSubscriptor = this.formsSrv.selectStarting().subscribe((starting: any) => {
            this.readyList = starting.initialized_forms;
            this.initView();
        });  
	}

    ngOnDestroy(): void {
        this.sessionSubscriptor.unsubscribe();
        this.formsListSubscriptor?.unsubscribe();
        this.formsInitializedSubscriptor?.unsubscribe();
    }

    initView(){
        if(!this.readyList || !this.forms  ){
            return;
        }
        this.status = this.STATUS_DONE;
        
    }

	protected load(){
        // load forms list in store
        this.formsSrv.loadForms();
	}

    onSelect(form: Form) {
        if(!form.active  || !this.readyList)
            return;

        this.router.navigate(['/settings/forms/', form.id]);
    }

    deactivate(form: Form) {
        this.formsSrv.deactiveForm(form.id);
    }

    activate(form: Form) {
        this.formsSrv.activeForm(form.id);
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-form":
                this.router.navigate(['/settings/forms/add']);
                break;
        }
    }
}
